var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_130_122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 76
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.706055,
    y: 0.365967,
    width: 75,
    height: 75,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_130_122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0186 50.366C23.4665 50.366 25.8493 50.6394 28.167 51.1863C30.4847 51.7332 32.7894 52.5535 35.0811 53.6472V22.866C32.9456 21.616 30.68 20.6785 28.2842 20.0535C25.8883 19.4285 23.4665 19.116 21.0186 19.116C19.1436 19.116 17.2816 19.2983 15.4326 19.6628C13.5837 20.0274 11.7998 20.5743 10.0811 21.3035V52.241C11.904 51.616 13.7139 51.1472 15.5107 50.8347C17.3076 50.5222 19.1436 50.366 21.0186 50.366ZM41.3311 53.6472C43.6227 52.5535 45.9274 51.7332 48.2451 51.1863C50.5628 50.6394 52.9456 50.366 55.3936 50.366C57.2686 50.366 59.1045 50.5222 60.9014 50.8347C62.6982 51.1472 64.5081 51.616 66.3311 52.241V21.3035C64.6123 20.5743 62.8285 20.0274 60.9795 19.6628C59.1305 19.2983 57.2686 19.116 55.3936 19.116C52.9456 19.116 50.5238 19.4285 48.1279 20.0535C45.7321 20.6785 43.4665 21.616 41.3311 22.866V53.6472ZM38.2061 62.866C35.7061 60.8868 32.9977 59.3503 30.0811 58.2566C27.1644 57.1628 24.1436 56.616 21.0186 56.616C18.8311 56.616 16.6826 56.9024 14.5732 57.4753C12.4639 58.0483 10.4456 58.8556 8.51855 59.8972C7.4248 60.4701 6.37012 60.4441 5.35449 59.8191C4.33887 59.1941 3.83105 58.2826 3.83105 57.0847V19.4285C3.83105 18.8556 3.97428 18.3087 4.26074 17.7878C4.5472 17.267 4.97689 16.8764 5.5498 16.616C7.94564 15.366 10.4456 14.4285 13.0498 13.8035C15.654 13.1785 18.3102 12.866 21.0186 12.866C24.0394 12.866 26.9951 13.2566 29.8857 14.0378C32.7764 14.8191 35.5498 15.991 38.2061 17.5535C40.8623 15.991 43.6357 14.8191 46.5264 14.0378C49.417 13.2566 52.3727 12.866 55.3936 12.866C58.1019 12.866 60.7581 13.1785 63.3623 13.8035C65.9665 14.4285 68.4665 15.366 70.8623 16.616C71.4352 16.8764 71.8649 17.267 72.1514 17.7878C72.4378 18.3087 72.5811 18.8556 72.5811 19.4285V57.0847C72.5811 58.2826 72.0732 59.1941 71.0576 59.8191C70.042 60.4441 68.9873 60.4701 67.8936 59.8972C65.9665 58.8556 63.9482 58.0483 61.8389 57.4753C59.7295 56.9024 57.5811 56.616 55.3936 56.616C52.2686 56.616 49.2477 57.1628 46.3311 58.2566C43.4144 59.3503 40.7061 60.8868 38.2061 62.866Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.fcd3c9964b75a1f5608ca6f3b7377ae7.svg";
export { ForwardRef as ReactComponent };